import React, { useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './DocumentsSubmitPage.css';

const DocumentsSubmitPage = () => {
  const [documents, setDocuments] = useState({
    businessRegistration: null,
    tinVatCertificate: null,
    ownerIdProof: null,
    businessLicense: null,
    addressProof: null
  });

  const handleFileChange = (documentType, file) => {
    setDocuments(prev => ({
      ...prev,
      [documentType]: file
    }));
  };

  const handleFileRemove = (documentType) => {
    setDocuments(prev => ({
      ...prev,
      [documentType]: null
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Submitting documents:', documents);
    // Handle form submission
  };

  const handleCancel = () => {
    setDocuments({
      businessRegistration: null,
      tinVatCertificate: null,
      ownerIdProof: null,
      businessLicense: null,
      addressProof: null
    });
  };

  const FileUploadIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.33464 10.6641V5.23073L5.6013 6.96406L4.66797 5.9974L8.0013 2.66406L11.3346 5.9974L10.4013 6.96406L8.66797 5.23073V10.6641H7.33464ZM4.0013 13.3307C3.63464 13.3307 3.32086 13.2003 3.05997 12.9394C2.79908 12.6785 2.66841 12.3645 2.66797 11.9974V9.9974H4.0013V11.9974H12.0013V9.9974H13.3346V11.9974C13.3346 12.3641 13.2042 12.6781 12.9433 12.9394C12.6824 13.2007 12.3684 13.3312 12.0013 13.3307H4.0013Z" fill="#333333"/>
    </svg>
  );

  const FileImageIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.63394 8.13828L3.25261 12.4183C3.06061 12.6583 3.25261 12.9983 3.56194 12.9983H10.3033C10.6233 12.9983 10.8046 12.6583 10.6126 12.4183L7.25261 8.13828C7.10328 7.93828 6.78328 7.93828 6.63394 8.13828Z" fill="#969696"/>
      <path d="M10.3667 10.0901L8.34008 12.6601C8.22275 12.8001 8.34008 13.0101 8.52142 13.0101H12.5641C12.7561 13.0101 12.8627 12.8101 12.7454 12.6601L10.7294 10.0901C10.7082 10.0622 10.6802 10.0395 10.6477 10.0238C10.6153 10.0082 10.5793 10 10.5427 10C10.5062 10 10.4702 10.0082 10.4378 10.0238C10.4053 10.0395 10.3773 10.0622 10.3561 10.0901H10.3667Z" fill="#969696"/>
      <path d="M10.6682 9C11.2573 9 11.7349 8.55228 11.7349 8C11.7349 7.44772 11.2573 7 10.6682 7C10.0791 7 9.60156 7.44772 9.60156 8C9.60156 8.55228 10.0791 9 10.6682 9Z" fill="#969696"/>
      <path d="M13.3331 16H2.66641C1.78107 16 1.06641 15.33 1.06641 14.5V1.5C1.06641 0.67 1.78107 0 2.66641 0H10.2291C10.6557 0 11.0611 0.16 11.3597 0.44L14.4637 3.35C14.7624 3.63 14.9331 4.01 14.9331 4.41V14.5C14.9331 15.33 14.2184 16 13.3331 16ZM2.66641 1C2.36774 1 2.13307 1.22 2.13307 1.5V14.5C2.13307 14.78 2.36774 15 2.66641 15H13.3331C13.6317 15 13.8664 14.78 13.8664 14.5V4.41C13.8673 4.34442 13.8535 4.27941 13.8259 4.21913C13.7984 4.15885 13.7576 4.10465 13.7064 4.06L10.6024 1.15C10.5039 1.05579 10.3698 1.00188 10.2291 1H2.66641Z" fill="#969696"/>
      <path d="M14.2736 5.00109H11.1696C10.3056 5.00109 9.60156 4.34109 9.60156 3.53109V0.621093C9.60156 0.341094 9.83623 0.121094 10.1349 0.121094C10.4336 0.121094 10.6682 0.341094 10.6682 0.621093V3.53109C10.6682 3.79109 10.8922 4.00109 11.1696 4.00109H14.2736C14.5722 4.00109 14.8069 4.22109 14.8069 4.50109C14.8069 4.78109 14.5722 5.00109 14.2736 5.00109Z" fill="#969696"/>
    </svg>
  );

  const DeleteIcon = () => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.08301 11.25C2.76217 11.25 2.48762 11.1359 2.25934 10.9076C2.03106 10.6793 1.91673 10.4046 1.91634 10.0833V2.5H1.33301V1.33333H4.24967V0.75H7.74967V1.33333H10.6663V2.5H10.083V10.0833C10.083 10.4042 9.96889 10.6789 9.74059 10.9076C9.51229 11.1362 9.23759 11.2504 8.91634 11.25H3.08301ZM8.91634 2.5H3.08301V10.0833H8.91634V2.5ZM4.24967 8.91667H5.41634V3.66667H4.24967V8.91667ZM6.58301 8.91667H7.74967V3.66667H6.58301V8.91667Z" fill="#FF0000"/>
    </svg>
  );

  const DocumentUploadSection = ({ title, documentType, hasFile }) => (
    <div className="document-upload-card">
      <h3 className="document-title">{title}</h3>
      <div className="document-upload-content">
        {hasFile ? (
          <div className="uploaded-file-section">
            <div className="file-info-row">
              <div className="file-badge">
                <FileImageIcon />
                <span className="file-name">Choose file.PDF</span>
              </div>
              <button 
                className="delete-btn"
                onClick={() => handleFileRemove(documentType)}
                type="button"
              >
                <DeleteIcon />
              </button>
            </div>
          </div>
        ) : null}
        <div className="file-upload-section">
          <div className="upload-input-wrapper">
            <label className="upload-input-label">
              <input
                type="file"
                accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                onChange={(e) => handleFileChange(documentType, e.target.files[0])}
                className="file-input-hidden"
              />
              <div className="upload-button">
                <FileUploadIcon />
                <span>Choose file</span>
              </div>
              <span className="upload-placeholder">Upload any attachment</span>
            </label>
          </div>
          <p className="upload-hint">Upload any file type. Maximum file size: 64MB</p>
        </div>
      </div>
    </div>
  );

  return (
    <div className="documents-submit-page">
      <Header />
      
      <main className="documents-main-content">
        <div className="documents-container">
          {/* Page Header */}
          <div className="page-header">
            <h1 className="page-title">Verification Badges (Optional Add-ons)</h1>
            <p className="page-subtitle">
              Boost your credibility and stand out — choose the badge level that matches your trust goals.
            </p>
          </div>

          {/* Verification Info Section */}
          <div className="verification-info">
            <div className="verification-header">
              <div className="verification-type">
                <span className="verify-label">Verify</span>
                <span className="verify-price">$99/year</span>
              </div>
              <p className="verification-description">
                Upload needed Company documents for reviewing.
              </p>
            </div>

            {/* Documents Form */}
            <form className="documents-form" onSubmit={handleSubmit}>
              <div className="documents-upload-section">
                <DocumentUploadSection 
                  title="Business Registration Certificate"
                  documentType="businessRegistration"
                  hasFile={documents.businessRegistration !== null}
                />

                <DocumentUploadSection 
                  title="TIN or VAT Certificate"
                  documentType="tinVatCertificate"
                  hasFile={documents.tinVatCertificate !== null}
                />

                <DocumentUploadSection 
                  title="Company Owner/Director ID Proof (Passport, National ID, or Driver's License)"
                  documentType="ownerIdProof"
                  hasFile={documents.ownerIdProof !== null}
                />

                <DocumentUploadSection 
                  title="Business License or Operating Permit"
                  documentType="businessLicense"
                  hasFile={documents.businessLicense !== null}
                />

                <DocumentUploadSection 
                  title="Proof of Company Address (Utility Bill or Lease Agreement)"
                  documentType="addressProof"
                  hasFile={documents.addressProof !== null}
                />
              </div>

              {/* Action Buttons */}
              <div className="form-actions">
                <button 
                  type="button" 
                  className="btn-cancel"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                <button 
                  type="submit" 
                  className="btn-submit"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default DocumentsSubmitPage;
